export const translations = {
  en: {
    nav: {
      services: "Services",
      about: "About",
      projects: "Projects",
      testimonials: "Reviews",
      area: "Area",
      contact: "Contact",
      quote: "Free Quote",
    },
    hero: {
      eyebrow: "Remodeling · Painting · Insulation",
      title_1: "Built with",
      title_2: "Precision.",
      title_3: "Finished with Pride.",
      subtitle:
        "Commercial, residential and industrial contracting. Painting, insulation, drywall, remodeling and more — delivered with safety, quality and reliability.",
      cta_primary: "Request a Free Quote",
      cta_secondary: "Explore Services",
      stat_1_v: "10+",
      stat_1_l: "Years of Experience",
      stat_2_v: "500+",
      stat_2_l: "Projects Completed",
      stat_3_v: "100%",
      stat_3_l: "Licensed & Insured",
    },
    services: {
      eyebrow: "What We Do",
      title: "Specialized Services",
      subtitle:
        "From a single coat of paint to full industrial insulation systems — we tailor every job to the client's needs.",
      learn_more: "Learn more",
      items: {
        painting: {
          name: "Painting",
          desc: "Interior & exterior painting for homes, offices and commercial buildings. Clean lines, durable finishes.",
        },
        insulation: {
          name: "Insulation",
          desc: "Residential and commercial insulation that lowers energy bills and improves comfort year-round.",
        },
        commercial_insulation: {
          name: "Commercial / Industrial Insulation",
          desc: "Mechanical insulation for pipes, ductwork, boilers, tanks and HVAC systems.",
        },
        drywall: {
          name: "Drywall",
          desc: "Installation, taping, finishing and repair of drywall with smooth, paint-ready surfaces.",
        },
        remodeling: {
          name: "Remodeling",
          desc: "Full-service remodeling for kitchens, bathrooms and commercial interiors.",
        },
        pressure_wash: {
          name: "Pressure Washing",
          desc: "Exterior pressure washing for facades, decks, driveways and industrial surfaces.",
        },
        cleaning: {
          name: "Cleaning",
          desc: "Post-construction and deep cleaning services — leave the site spotless and move-in ready.",
        },
      },
    },
    about: {
      eyebrow: "Why DV Solutions",
      title: "Safety. Quality. Reliability.",
      p1: "DV Solutions Inc. is a remodeling and painting contractor delivering multi-disciplinary services to residential, commercial and industrial clients. We treat every project — large or small — with the same commitment to craftsmanship and accountability.",
      p2: "Our crews are trained, insured and equipped to handle the full scope of your build: from prep and protection to the final coat. We coordinate tightly, communicate clearly and finish on time.",
      bullet_1: "Licensed & fully insured",
      bullet_2: "OSHA-conscious safety standards",
      bullet_3: "Free, no-pressure estimates",
      bullet_4: "Bilingual team (English / Spanish)",
      cta: "Talk to our team",
    },
    projects: {
      eyebrow: "Selected Work",
      title: "Recent Projects",
      subtitle:
        "A look at real jobs — including commercial rooftop pipe insulation for HVAC and mechanical systems.",
    },
    testimonials: {
      eyebrow: "What clients say",
      title: "Real Words. Real Jobs.",
      subtitle: "A few notes from people who hired us — homeowners, property managers, and facility teams.",
      items: [
        {
          quote: "DV's crew showed up on time, taped everything off, and left the house cleaner than they found it. The paint job still looks crisp two winters later.",
          name: "Maria S.",
          role: "Homeowner",
          city: "Reading, PA",
        },
        {
          quote: "We needed urgent pipe insulation on our rooftop HVAC before the cold snap. They scoped it the same day and finished the run in under a week — fully buttoned up.",
          name: "Brian K.",
          role: "Facility Manager",
          city: "Allentown, PA",
        },
        {
          quote: "Honest pricing, no surprise charges, and the drywall finish was flawless. Already booked them for the basement remodel.",
          name: "Jen & Carlos R.",
          role: "Homeowners",
          city: "Bethlehem, PA",
        },
        {
          quote: "Bilingual team made coordinating with our crew much easier. Quality of the commercial painting is hands-down the best we've had in three years.",
          name: "David T.",
          role: "Property Manager",
          city: "Philadelphia, PA",
        },
      ],
    },
    service_area: {
      eyebrow: "Where we work",
      title: "Service Area",
      subtitle:
        "Based in Eastern Pennsylvania. We serve homeowners and businesses across PA, NJ and the surrounding tri-state region — and we'll travel for larger commercial and industrial projects.",
      bullet_primary: "Primary coverage: Eastern PA (Berks, Lehigh, Bucks, Montgomery, Philadelphia counties)",
      bullet_secondary: "Extended coverage: New Jersey, Delaware, parts of New York",
      bullet_travel: "Travel for large commercial / industrial projects on request",
      cta: "Not sure if we cover your area? Call us.",
    },
    contact: {
      eyebrow: "Get a Quote",
      title: "Start Your Project",
      subtitle:
        "Tell us about your space. We respond within one business day with a clear, no-pressure estimate.",
      form: {
        name: "Full Name",
        email: "Email Address",
        phone: "Phone Number",
        service: "Service Needed",
        message: "Project Details",
        message_ph: "Tell us about the scope, timing, and any specifics...",
        submit: "Send Request",
        submitting: "Sending...",
        success: "Thanks! We received your request and will contact you soon.",
        error: "Something went wrong. Please call us at 484-513-6989.",
        select_service: "Select a service",
      },
      info: {
        phone_label: "Call us",
        email_label: "Email us",
        hours_label: "Hours",
        hours_value: "Mon – Sat · 7am – 7pm",
        area_label: "Service Area",
        area_value: "Available across the region. Travel for larger projects.",
      },
    },
    footer: {
      tagline: "Remodeling & Painting Contractor",
      services_title: "Services",
      company_title: "Company",
      contact_title: "Contact",
      rights: "All rights reserved.",
      built_with_care: "Built with care for the trades.",
    },
    admin: {
      title: "Quote Requests",
      subtitle: "Inbound leads from the contact form.",
      empty: "No requests yet.",
      headers: {
        date: "Date",
        name: "Name",
        contact: "Contact",
        service: "Service",
        message: "Message",
        status: "Status",
        actions: "Actions",
      },
      mark_contacted: "Mark contacted",
      mark_closed: "Close",
      delete: "Delete",
      back: "Back to site",
    },
  },
  es: {
    nav: {
      services: "Servicios",
      about: "Nosotros",
      projects: "Proyectos",
      testimonials: "Reseñas",
      area: "Área",
      contact: "Contacto",
      quote: "Cotización",
    },
    hero: {
      eyebrow: "Remodelación · Pintura · Aislamiento",
      title_1: "Construido con",
      title_2: "Precisión.",
      title_3: "Terminado con Orgullo.",
      subtitle:
        "Contratistas comerciales, residenciales e industriales. Pintura, aislamiento, drywall, remodelación y más — con seguridad, calidad y confianza.",
      cta_primary: "Solicitar Cotización Gratis",
      cta_secondary: "Ver Servicios",
      stat_1_v: "10+",
      stat_1_l: "Años de Experiencia",
      stat_2_v: "500+",
      stat_2_l: "Proyectos Completados",
      stat_3_v: "100%",
      stat_3_l: "Licenciados y Asegurados",
    },
    services: {
      eyebrow: "Qué Hacemos",
      title: "Servicios Especializados",
      subtitle:
        "Desde una sola capa de pintura hasta sistemas completos de aislamiento industrial — cada trabajo se adapta al cliente.",
      learn_more: "Saber más",
      items: {
        painting: {
          name: "Pintura",
          desc: "Pintura interior y exterior para casas, oficinas y edificios comerciales. Líneas limpias, acabados duraderos.",
        },
        insulation: {
          name: "Aislamiento",
          desc: "Aislamiento residencial y comercial que reduce el consumo de energía y mejora el confort.",
        },
        commercial_insulation: {
          name: "Aislamiento Comercial / Industrial",
          desc: "Aislamiento mecánico para tuberías, ductos, calderas, tanques y sistemas HVAC.",
        },
        drywall: {
          name: "Drywall",
          desc: "Instalación, masillado, acabado y reparación de drywall con superficies listas para pintar.",
        },
        remodeling: {
          name: "Remodelación",
          desc: "Remodelación integral de cocinas, baños e interiores comerciales.",
        },
        pressure_wash: {
          name: "Lavado a Presión",
          desc: "Lavado a presión de fachadas, terrazas, entradas y superficies industriales.",
        },
        cleaning: {
          name: "Limpieza",
          desc: "Limpieza post-construcción y profunda — entregamos el sitio impecable.",
        },
      },
    },
    about: {
      eyebrow: "Por qué DV Solutions",
      title: "Seguridad. Calidad. Confianza.",
      p1: "DV Solutions Inc. es un contratista de remodelación y pintura que ofrece servicios multidisciplinarios a clientes residenciales, comerciales e industriales. Tratamos cada proyecto — grande o pequeño — con el mismo compromiso de calidad y responsabilidad.",
      p2: "Nuestro equipo está capacitado, asegurado y equipado para manejar todo el alcance de tu obra: desde la preparación y protección hasta la capa final. Coordinamos, comunicamos y entregamos a tiempo.",
      bullet_1: "Licenciados y totalmente asegurados",
      bullet_2: "Estándares de seguridad conscientes de OSHA",
      bullet_3: "Estimados gratis, sin presión",
      bullet_4: "Equipo bilingüe (Inglés / Español)",
      cta: "Habla con nuestro equipo",
    },
    projects: {
      eyebrow: "Trabajos Seleccionados",
      title: "Proyectos Recientes",
      subtitle:
        "Una mirada a obras reales — incluyendo aislamiento comercial de tuberías en techo para sistemas HVAC y mecánicos.",
    },
    testimonials: {
      eyebrow: "Lo que dicen los clientes",
      title: "Palabras Reales. Trabajos Reales.",
      subtitle: "Algunas notas de personas que nos contrataron — propietarios, administradores y equipos de facilidades.",
      items: [
        {
          quote: "El equipo de DV llegó a tiempo, protegió todo y dejó la casa más limpia que cuando llegaron. La pintura sigue impecable dos inviernos después.",
          name: "Maria S.",
          role: "Propietaria",
          city: "Reading, PA",
        },
        {
          quote: "Necesitábamos aislamiento urgente en el HVAC del techo antes del frío. Lo cotizaron el mismo día y terminaron el tramo en menos de una semana — totalmente sellado.",
          name: "Brian K.",
          role: "Gerente de Facilidades",
          city: "Allentown, PA",
        },
        {
          quote: "Precios honestos, sin cargos sorpresa, y el acabado del drywall fue impecable. Ya los contraté de nuevo para remodelar el sótano.",
          name: "Jen y Carlos R.",
          role: "Propietarios",
          city: "Bethlehem, PA",
        },
        {
          quote: "El equipo bilingüe facilitó muchísimo la coordinación. La calidad de la pintura comercial es la mejor que hemos tenido en tres años.",
          name: "David T.",
          role: "Administrador de Propiedad",
          city: "Philadelphia, PA",
        },
      ],
    },
    service_area: {
      eyebrow: "Dónde trabajamos",
      title: "Área de Servicio",
      subtitle:
        "Basados en el Este de Pensilvania. Atendemos hogares y negocios en PA, NJ y la región tri-estatal — y viajamos para proyectos comerciales e industriales más grandes.",
      bullet_primary: "Cobertura principal: Este de PA (condados de Berks, Lehigh, Bucks, Montgomery, Philadelphia)",
      bullet_secondary: "Cobertura extendida: New Jersey, Delaware, partes de New York",
      bullet_travel: "Viajamos para grandes proyectos comerciales/industriales a solicitud",
      cta: "¿No estás seguro si cubrimos tu área? Llámanos.",
    },
    contact: {
      eyebrow: "Solicita Cotización",
      title: "Empieza tu Proyecto",
      subtitle:
        "Cuéntanos sobre tu espacio. Respondemos en un día hábil con un estimado claro y sin presión.",
      form: {
        name: "Nombre Completo",
        email: "Correo Electrónico",
        phone: "Teléfono",
        service: "Servicio Requerido",
        message: "Detalles del Proyecto",
        message_ph: "Cuéntanos del alcance, tiempos y cualquier detalle...",
        submit: "Enviar Solicitud",
        submitting: "Enviando...",
        success: "¡Gracias! Recibimos tu solicitud y te contactaremos pronto.",
        error: "Algo salió mal. Llámanos al 484-513-6989.",
        select_service: "Selecciona un servicio",
      },
      info: {
        phone_label: "Llámanos",
        email_label: "Escríbenos",
        hours_label: "Horario",
        hours_value: "Lun – Sáb · 7am – 7pm",
        area_label: "Área de Servicio",
        area_value: "Disponible en toda la región. Viajamos para proyectos grandes.",
      },
    },
    footer: {
      tagline: "Contratista de Remodelación y Pintura",
      services_title: "Servicios",
      company_title: "Compañía",
      contact_title: "Contacto",
      rights: "Todos los derechos reservados.",
      built_with_care: "Hecho con cuidado para los oficios.",
    },
    admin: {
      title: "Solicitudes de Cotización",
      subtitle: "Solicitudes entrantes del formulario de contacto.",
      empty: "Aún no hay solicitudes.",
      headers: {
        date: "Fecha",
        name: "Nombre",
        contact: "Contacto",
        service: "Servicio",
        message: "Mensaje",
        status: "Estado",
        actions: "Acciones",
      },
      mark_contacted: "Marcar contactado",
      mark_closed: "Cerrar",
      delete: "Eliminar",
      back: "Volver al sitio",
    },
  },
};

export const SERVICE_KEYS = [
  "painting",
  "insulation",
  "commercial_insulation",
  "drywall",
  "remodeling",
  "pressure_wash",
  "cleaning",
];
